import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAllPodcasts } from '../apiCalls/podcasts/api_v1_podcasts';
import dummyImg from '../static/img/home/ga_dummy_img.avif'

function GamezGuides({ skillLevel }) {
    const navigate = useNavigate();
    const [guides, setGuides] = useState([]);
    const [loading, setLoading] = useState(false);
    const [guidesSet, setGuidesSet] = useState(new Set());
    const [hasMoreGuides, setHasMoreGuides] = useState(true);
    const path = window.location.pathname;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const gameUuid = queryParams.get('uuid');

    useEffect(() => {
        const fetchStories = async () => {
            try {
                // let skillLevel = localStorage.getItem("skillLevel");
                if (path === '/game' && gameUuid && gameUuid.trim() !== '') {
                    // console.log(gameUuid);
                    const response = await getAllPodcasts({ "uuid": gameUuid, "skillLevel": skillLevel });
                    if (response.status === 200) {
                        const initialGuides = response.data.data.podcasts;
                        setGuides(initialGuides);
                        setGuidesSet(new Set(initialGuides.map(guide => guide.uuid)));
                    }
                }
                else {
                    console.log(skillLevel)
                    const response = await getAllPodcasts({ "skillLevel": skillLevel });
                    if (response.status === 200) {
                        const initialGuides = response.data.data.podcasts;
                        setGuides(initialGuides);
                        setGuidesSet(new Set(initialGuides.map(guide => guide.uuid)));
                        // console.log(response.data.data.podcasts)
                    }
                }

            } catch (error) {
                console.error('Error fetching stories:', error);
            }
        };
        fetchStories();
    }, [skillLevel]);

    const fetchMoreGuides = async () => {
        setLoading(true);
        try {
            let response;
            if (path === '/game' && gameUuid && gameUuid.trim() !== '') {
                response = await getAllPodcasts({ "skillLevel": skillLevel, "uuid": gameUuid });
            }
            else {
                response = await getAllPodcasts({ "skillLevel": skillLevel });
            }
            if (response.status === 200) {
                const newGuides = response.data.data.podcasts;
                const uniqueNewGuides = newGuides.filter(guide => !guidesSet.has(guide.uuid));
                
                if (uniqueNewGuides.length === 0) {
                    setHasMoreGuides(false);
                } else {
                    setGuides(prevGuides => [...prevGuides, ...uniqueNewGuides]);
                    setGuidesSet(prevSet => new Set([...prevSet, ...uniqueNewGuides.map(guide => guide.uuid)]));
                }
            }
        } catch (error) {
            console.error('Error fetching more guides:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleGuideClick = (uuid) => {
        // console.log("FROM PODCAST SCREEN " + uuid)
        navigate(`/guides?uuid=${uuid}`);
    };

    return (
        <Box
            sx={{
                p: path === '/guides' ? 0 : 2,
                color: 'white',
                maxWidth: '1200px',
            }}
        >
            <Typography variant="h6" gutterBottom>
                Gamez Guides
            </Typography>
            <Grid container spacing={2}>
                {guides.map((guide) => (
                    <Grid
                        item
                        key={guide.uuid}
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        onClick={() => handleGuideClick(guide.uuid)}
                        sx={{ cursor: 'pointer' }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                minHeight: '120px',
                            }}
                        >
                            <Box
                                component="img"
                                loading='lazy'
                                src={guide.thumbnail}
                                onError={e => { e.target.onerror = null; e.target.src = dummyImg; }}

                                sx={{
                                    width: '180px',
                                    height: '120px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                    marginRight: '16px',
                                }}
                            />
                            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', p: 1 }}>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontWeight: '500',
                                        fontSize: '1rem',
                                        color: 'white',
                                        textAlign: 'start',
                                        lineHeight: 1.4,
                                    }}
                                >
                                    {guide.title}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            {hasMoreGuides ? (
                <Button
                    onClick={fetchMoreGuides}
                    sx={{
                        mt: 2,
                        color: 'grey.500',
                        textTransform: 'none',
                        display: 'block',
                        width: '100%',
                    }}
                    disabled={loading}
                >
                    {loading ? 'Loading...' : 'More Guides'}
                </Button>
            ) : (
                <Typography
                    sx={{
                        mt: 2,
                        color: 'grey.500',
                        textAlign: 'center',
                        width: '100%',
                    }}
                >
                    No more guides available for this skill level
                </Typography>
            )}
        </Box>
    );
}

export default GamezGuides;